import React from 'react';

const SearchIcon = (props) => {
    const { style, width } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>Asset 6</title>
            <g id="Layer_2" data-name="Layer 2">
                <g id="info">
                    <path
                        d="M15.61,13.72l-3.48-3.48-.06,0a6.58,6.58,0,1,0-1.88,1.88l0,.06,3.48,3.48a1.34,1.34,0,0,0,1.89-1.89Zm-9-2.84a4.3,4.3,0,1,1,4.3-4.3A4.3,4.3,0,0,1,6.58,10.88Z"/>
                </g>
            </g>
        </svg>
    )
};

export default SearchIcon;